$(document).ready(function () {
    $(".js-async-form-submit").submit(function (event) {
        // zakaž propagaci eventu
        event.preventDefault();
        // form
        var form = $(this);

        // vypni mi submit button
        var submitButtons = form.find('button[type="submit"]');
        submitButtons.prop("disabled", true);
        
        form.find(".js-success").hide();
        form.find(".js-error").hide();
        // ajax submit
        $.ajax({
            type: "POST",
            data: form.serialize(),
            contentType: 'application/x-www-form-urlencoded', 
            // enctype: 'multipart/form-data', - tohle neumí zatím pygrim
            // processData: false,  // tohle je důležité kvůli souborům
            // data: new FormData(form[0]),
            // contentType: false,
            url: form.prop("action"),
            cache: false,
            timeout: 600000,
            success: function (data) {
                form.find(".js-success").html(data["status_message"]).show();

                // zapni submit button
                submitButtons.prop("disabled", false);

            },
            error: function (e) {
                if (e.responseJSON && e.responseJSON["status_message"]){
                form.find(".js-error").html(e.responseJSON["status_message"]).show();
                } else {
                    form.find(".js-error").html("Nepodařilo se odeslat.").show();
                }
                // zapni submit button
                submitButtons.prop("disabled", false);

            }
        });
        // pro jistotu false aby se neprovedl submit
        return false;
    });
});
